// 获取当前访问的协议和主机
const getCurrentOrigin = (): string => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return '';
};

// 允许的域名列表
const ALLOWED_DOMAINS = [
  'http://tongbudaojia.com',
  'https://tongbudaojia.com',
  'http://www.tongbudaojia.com',
  'https://www.tongbudaojia.com',
  'https://8.129.132.69',
  'https://127.0.0.1',
];

// 默认域名（当当前域名不在允许列表中时使用）
const DEFAULT_DOMAIN = 'https://tongbudaojia.com';

// 获取 API 基础 URL
export const getApiBaseUrl = (): string => {
  const currentOrigin = getCurrentOrigin();
  if (currentOrigin && ALLOWED_DOMAINS.includes(currentOrigin)) {
    return currentOrigin;
  }
  return DEFAULT_DOMAIN;
};

// 获取后台管理 URL
export const getBackendUrl = (): string => {
  return getApiBaseUrl();
};

// 获取图片基础 URL（始终使用图片服务器）
export const getImageBaseUrl = (): string => {
  return process.env.REACT_APP_IMAGE_BASE_URL || 'https://image.tongbudaojia.com';
};
